import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { CreateEstimateResult } from "../types/CreateEstimateResult";

export const useCreateEstimate = (
	retailOrderID: number,
	onSuccess: (result: CreateEstimateResult) => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async () => {
			return await apiClient.post("retail-order/create-estimate",
				{ retailOrderID: retailOrderID }) as CreateEstimateResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess(result);
			else
				onError('Error when creating estimate: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
